<script>
  import { Link } from "svelte-navigator";
  import { selectedRaceId } from '../stores';

  
  export let id;
  export let name;
  export let date;
  export let completed;
  export let location;
  export let color;

 
  function onRaceButtonClick(race_id) {
    selectedRaceId.set(race_id);
  }
</script>

<div class="col-lg-4">
  <div class="card card-margin shadow-sm">
      <div class="card-body pt-0">
          <div class="widget-49">
              <div class="widget-49-title-wrapper">
                    <div class="container-background" style="background-color:{color};padding:30px;">
                    <!--<div class="container-background" style="padding:30px;">-->
                      <div>Race</div>
                      <div class="widget-49-date-day fs-1" style="color:black;font-weight:500;">{id}</div>
                    </div>
                  
                  <div class="widget-49-meeting-info text-start" style="letter-spacing: 1px;">
                      <span class="widget-49-pro-title" style="font-weight:800; text-transform:uppercase;">{name}</span>
                      <span class="widget-49-pro-title" style="color: #727686;">{location}</span>
                      <span class="widget-49-meeting-time">{date}</span>
                  </div>
              </div>
              
            {#if completed}
            <Link to="category_list">
              <div class="widget-49-meeting-action">
                <a href="#" class="btn btn-sm btn-flash-border-primary" on:click="{() => {onRaceButtonClick(id);}}">View Results</a>
              </div>
            </Link>
          {:else}
              <div class="widget-49-meeting-action">
                  <!-- &nbsp -->
                  
                  <Link to="race_info">
                    <div class="widget-49-meeting-action">
                      <a href="#" class="btn btn-sm btn-flash-border-primary" on:click="{() => {onRaceButtonClick(id);}}">Race Details</a>
                    </div>
                  </Link>
                
              </div>
          {/if}

          </div>
      </div>
  </div>
</div>


<style>
.card-margin {
    margin-bottom: 1rem;
}

.card {
    border: 0;
    margin-bottom: 25px;
}
.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #ffffff;
    background-clip: border-box;
    border: 1px solid #e6e4e9;
    border-radius: 8px;
}

.widget-49 .widget-49-title-wrapper {
  display: flex;
  align-items: center;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-primary .widget-49-date-day {
  color: #4e73e5;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-secondary .widget-49-date-day {
  color: #dde1e9;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-success .widget-49-date-day {
  color: #17d1bd;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-info .widget-49-date-day {
  color: #36afff;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-warning .widget-49-date-day {
  color: #FFC868;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-danger .widget-49-date-day {
  color: #F95062;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-light .widget-49-date-day {
  color: #f7f9fa;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-dark .widget-49-date-day {
  color: #394856;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-base .widget-49-date-day {
  color: #68CBD7;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-meeting-info {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
}

.widget-49 .widget-49-title-wrapper .widget-49-meeting-info .widget-49-pro-title {
  color: #3c4142;
  font-size: .75rem;
  font-weight: 500;
}

.widget-49 .widget-49-title-wrapper .widget-49-meeting-info .widget-49-meeting-time {
  color: #B1BAC5;
  /*font-size: 13px;*/
  font-size: .75rem;
}

.widget-49 .widget-49-meeting-points .widget-49-meeting-item span {
  margin-left: .5rem;
}

.widget-49 .widget-49-meeting-action {
  text-align: right;
}

.widget-49 .widget-49-meeting-action a {
  text-transform: uppercase;
}
</style>